import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetOrderStates } from '../Actions';

export function useResetViewOrderOnUnmount(): void {
    const dispatch = useDispatch<any>();

    useEffect(
        () => () => {
            dispatch(resetOrderStates());
        },
        [dispatch]
    );
}
